var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "container" } }, [
    _c("div", { staticClass: "detailPatent" }, [
      _c("table", [
        _c("tr", [
          _c("td", [_vm._v("Nombre")]),
          _c("td", [_vm._v(_vm._s(_vm.detail.name))])
        ]),
        _c("tr", [
          _c("td", [_vm._v("Estado")]),
          _c("td", [_vm._v(_vm._s(_vm.detail.estado))])
        ]),
        _c("tr", [
          _c("td", [_vm._v("Id Cámara")]),
          _c("td", [_vm._v(_vm._s(_vm.detail.id_camara))])
        ]),
        _c("tr", [
          _c("td", [_vm._v("Sistema")]),
          _c("td", [_vm._v(_vm._s(_vm.detail.sistema))])
        ]),
        _c("tr", [
          _c("td", [_vm._v("Canales")]),
          _c("td", { staticStyle: { cursor: "pointer" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "flex-start",
                  "align-items": "center"
                }
              },
              _vm._l(_vm.detail.children, function(icon) {
                return _c(
                  "v-tooltip",
                  {
                    key: icon.id,
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function(ref) {
                            var on = ref.on
                            return [
                              _c(
                                "v-icon",
                                _vm._g({ attrs: { flat: "" } }, on),
                                [_vm._v("videocam")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [_c("span", [_vm._v("Canal " + _vm._s(icon.name))])]
                )
              }),
              1
            )
          ])
        ]),
        _c("tr", [
          _c("td", [_vm._v("última Conexión")]),
          _c("td", [_vm._v(_vm._s(_vm.detail.ultima_conexion))])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }